// extracted by mini-css-extract-plugin
module.exports = {"productTitle":"Products_productTitle__1O7rg","productImg":"Products_productImg__3wTBh"};